module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ws-81cbff3db85ab05a4ac816a8ab047727.svg";